import { render, staticRenderFns } from "./otherQuestionsTM.vue?vue&type=template&id=6d448657&scoped=true&"
import script from "./otherQuestionsTM.vue?vue&type=script&lang=js&"
export * from "./otherQuestionsTM.vue?vue&type=script&lang=js&"
import style0 from "./otherQuestionsTM.vue?vue&type=style&index=0&id=6d448657&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d448657",
  null
  
)

export default component.exports